import {
    apiUrl,
    getParameters,
    InitiateResponse,
    spawnErrorOverlay,
} from "./common";
import { PhotoPlayer } from "./components/photoPlayer";
import { VideoPlayer } from "./components/videoPlayer";
import { PdfPlayer } from "./components/pdfPlayer";
import { StatusOverlay } from "./components/statusOverlay";

export class App {
    private createPlayer(data: InitiateResponse) {
        const socket = document.getElementById("player-socket");
        if (!socket || !(socket instanceof HTMLDivElement)) {
            alert("Socket not found");
            return;
        }
        const mimeType = data.mimeType;
        console.log("MIME type:", mimeType);
        if (
            data.mimeType.startsWith("video") ||
            data.mimeType.startsWith("audio")
        ) {
            new VideoPlayer(data, socket);
            return;
        }
        if (data.mimeType.startsWith("image")) {
            new PhotoPlayer(data, socket);
            return;
        }
        if (data.mimeType == "application/pdf") {
            new PdfPlayer(data, socket);
            return;
        }
        spawnErrorOverlay(
            JSON.stringify({
                error: "Unsupported MIME type",
                mimeType,
            })
        );
    }

    public async initiate() {
        const { payload, signature } = getParameters();
        const fetchOptions: RequestInit = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ payload, signature }),
        };
        console.log("fetchOptions:", fetchOptions);
        try {
            const response = await fetch(
                `${apiUrl}/protected/initiate`,
                fetchOptions
            );
            if (!response.ok) {
                const error = await response.text();

                if (response.status === 400) {
                    spawnErrorOverlay("Bad payload generated by the client");
                }

                spawnErrorOverlay(error);
                return;
            }

            const data = (await response.json()) as InitiateResponse;
            this.createPlayer(data);
            new StatusOverlay(data);
        } catch (error) {
            const errorMessage =
                error instanceof Error
                    ? error.message
                    : "An unknown error occurred";
            spawnErrorOverlay(errorMessage);
        }
    }
}
